module.exports = __webpack_public_path__ + "static/media/landing_course5.11cd0505.png";